import { API_BASE, authHeaders } from './apiAuth'

/**
 * Expand on the board (Huanrui, 2026-10-26): Bria Expand through fal, by way
 * of the Worker (workers/api/src/routes/expand.ts). $0.04 a picture.
 *
 * The board sends a copy of the picture at the size Bria works at, the size
 * of the new picture, and where the picture sits in it. What comes back is
 * kept as a project file as Bria made it; the board then lays the full-size
 * original back over it (ProjectCanvas, expandPicture).
 */
export const FAL_EXPAND_CREDITS = 40

async function reason(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as { error?: string }
    if (body?.error) return body.error
  } catch {
    /* not JSON */
  }
  return `HTTP ${response.status}`
}

export interface ExpandAsk {
  projectId: string
  /** The picture as Bria is to see it. */
  picture: Blob
  /** The new picture's size, in Bria's pixels. */
  canvas: { w: number; h: number }
  /** Where the picture sits in it, and its size there, in Bria's pixels. */
  place: { x: number; y: number; w: number; h: number }
  prompt: string
  from: string
  title: string
}

/** Answers Bria's picture: its project file id and size. */
export async function expandWithFal(ask: ExpandAsk): Promise<{ fileId: string; width: number; height: number }> {
  const project = encodeURIComponent(ask.projectId)
  const query = new URLSearchParams({
    project: ask.projectId,
    cw: String(ask.canvas.w),
    ch: String(ask.canvas.h),
    ox: String(ask.place.x),
    oy: String(ask.place.y),
    ow: String(ask.place.w),
    oh: String(ask.place.h),
    prompt: ask.prompt,
  })
  const started = await fetch(`${API_BASE}/api/canvas-expand?${query.toString()}`, {
    method: 'POST',
    headers: { 'Content-Type': ask.picture.type, ...(await authHeaders()) },
    body: ask.picture,
  })
  if (!started.ok) throw new Error(await reason(started))
  const { task } = (await started.json()) as { task?: string }
  if (!task) throw new Error('fal did not take it')

  const startedAt = Date.now()
  let misses = 0
  for (;;) {
    await new Promise((wake) => setTimeout(wake, 2500))
    if (Date.now() - startedAt > 5 * 60 * 1000) throw new Error('No answer from fal after five minutes')
    try {
      const asked = await fetch(
        `${API_BASE}/api/canvas-expand?project=${project}&task=${encodeURIComponent(task)}` +
          `&from=${encodeURIComponent(ask.from)}&title=${encodeURIComponent(ask.title)}`,
        { headers: await authHeaders() },
      )
      if (!asked.ok) throw new Error(await reason(asked))
      const body = (await asked.json()) as { state?: string; fileId?: string; width?: number; height?: number; error?: string }
      misses = 0
      if (body.state === 'done' && body.fileId) {
        console.info(`[WonderWorks] expand: fal answered in ${Math.round((Date.now() - startedAt) / 1000)} s`)
        return { fileId: body.fileId, width: body.width ?? 0, height: body.height ?? 0 }
      }
      if (body.state === 'failed') throw Object.assign(new Error(body.error || 'It could not be expanded'), { final: true })
    } catch (error) {
      if ((error as { final?: boolean }).final) throw error
      misses += 1
      if (misses >= 5) throw error
    }
  }
}
